import { Outlet } from "react-router-dom";
import { MeshGradientBackground } from "@/components/MeshGradientBackground";

export default function LetsBeginLayout() {
  return (
    <div className="fixed inset-0 bg-black" style={{ overscrollBehavior: 'none' }}>
      {/* Persistent animated mesh gradient background */}
      <MeshGradientBackground />
      
      {/* Page content rendered on top */}
      <div className="relative z-10 h-full overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
